import { useQuery } from 'react-query';
import {
  getBettieFeedComments,
  type GetBettieFeedCommentsQuery,
  type GetBettieFeedCommentsResponse
} from '../../services/bettieFeedService';

export function useGetBettieFeedComments(
  chatRoomId: string,
  postId: string,
  query: GetBettieFeedCommentsQuery = { page: 1, per_page: 50 }
) {
  return useQuery<GetBettieFeedCommentsResponse, Error>(
    ['bettieFeedComments', chatRoomId, postId, query.page, query.per_page],
    () => getBettieFeedComments(chatRoomId, postId, query),
    {
      enabled: !!chatRoomId && !!postId,
      staleTime: 10 * 1000,
      cacheTime: 60 * 1000
    }
  );
}
